<template>
    <div class="empty-error text text-red" v-if="showEmptyError">
        {{ $t('empty_error') }}
    </div>
</template>

<script>
    export default {
        props: {
            showEmptyError: {
                type: Boolean,
                default: false
            }
        }
    }
</script>
